module.exports = __webpack_public_path__ + "web/img/img.3033d180.png";